import { render, staticRenderFns } from "./monthworkview.vue?vue&type=template&id=631dd816&scoped=true&"
import script from "./monthworkview.vue?vue&type=script&lang=js&"
export * from "./monthworkview.vue?vue&type=script&lang=js&"
import style0 from "./monthworkview.vue?vue&type=style&index=0&id=631dd816&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631dd816",
  null
  
)

export default component.exports